/*
 app dependencies
 - var body

 lib dependencies
*/

const scSidebarOwnerFilters = (function($)
{
    //public
    const   sidebarId = 'owner-filters',
            overviewWrapSelector = '.js-owners-overview';
    //private
    const   _triggers = document.querySelectorAll(`.js-show-sidebar[data-sidebar-id="${sidebarId}"]`),
            _bodyToggleClass = `show-sidebar-${sidebarId}`,
            //_overviewWrapSelector = '.js-owners-overview',
            _filterButtonWrap = document.querySelector('.js-filter-btn-wrap'),
            _summaryWrap = document.querySelector('.js-filter-owner-summary'),
            _textFields = ["Name"],
            _radioFields = ["Type","Organisation"];
    let     _sidebarDiv,
            _form;

	//module functions
	function init()
	{
		for (const trigger of _triggers)
        {
            trigger.addEventListener('click', function(e)
            {
                e.preventDefault();
                _show();
            });
        }
	}

    function _show()
    {
        scSidebar.show(_bodyToggleClass);
    }

    function contentLoaded(sidebarDiv)
    {
        scSidebarFilters.contentLoaded(sidebarDiv, this);

        _form = sidebarDiv.querySelector('form');

        /*
        //references to elements
        _sidebarDiv = sidebarDiv;
        _form = _sidebarDiv.querySelector('form');

        //init
        scOptionSearch.init(sidebarDiv);

        _form.addEventListener('submit', function(e)
        {
            e.preventDefault();

            const newUrl = _getSearchUrl();

            //hide sidebar
            scSidebar.hide();

            //show overview loader
            document.querySelector(_overviewWrapSelector).classList.add('loading-container--loading');

            //ajax call
            doAjax({
                ajaxUrl: newUrl,
                onSuccess: _onUpdateSuccess,
                onError: _onUpdateError,
                params: {
                    newUrl
                }
            })
        });
        */

    }

        /*function _getSearchUrl()
        {
            const params = $(_form).find("input").filter(function()
            {
                return this.value.trim().length > 0
            }).serialize();

            return `${_form.getAttribute('action')}?${params}`;
        }

        function _onUpdateSuccess(response, params)
        {
            document.querySelector(_overviewWrapSelector).classList.remove('loading-container--loading');

            try
            {
                //parse html from response
                const parser = new DOMParser();
                const loadedDoc = parser.parseFromString(response, "text/html");
                const newOverviewWrap = loadedDoc.querySelector(_overviewWrapSelector);
                if (newOverviewWrap)
                {
                    const newHtml = newOverviewWrap.outerHTML;
                    //set new html
                    document.querySelector(_overviewWrapSelector).outerHTML = newHtml;
                    //update url
                    history.pushState({}, document.title, params.newUrl);
                    //update summary
                    const summary = _constructSummary();
                    if (summary)
                    {
                        _filterButtonWrap.classList.add('filter-btn-wrap--with-summary');
                        _summaryWrap.innerHTML = summary;
                    }
                    else
                    {
                        _filterButtonWrap.classList.remove('filter-btn-wrap--with-summary');
                        _summaryWrap.innerHTML = '';
                    }
                }
                else
                {
                    throw 'Er is iets misgegaan bij het ophalen van de resultaten';
                }
            }
            catch (err)
            {
                lmnDialog.alert(`<p>${err}</p>`);
            }
        }*/

            function _constructSummary()
            {
                let summary = '';
                const defaultVal = 'Geen voorkeur';

                //Politieke partijen met zoekterm vv gelieerd aan VVD

                //type
                if (document.querySelector('.js-filter-owners-label-type').textContent.trim() != defaultVal)
                {
                    summary += document.querySelector('.js-filter-owners-label-type').textContent.trim();
                }
                else
                {
                    summary += 'Alle personen en organisaties';
                }

                //search
                if (document.querySelector('.js-filter-owners-search-input').value != '')
                {
                    summary += ` met zoekterm <span class="filter-btn-wrap__highlight">'${document.querySelector('.js-filter-owners-search-input').value}'</span>`;
                }

                //organisation
                if (document.querySelector('.js-filter-owners-label-organisation').textContent.trim() != defaultVal)
                {
                    summary += ` gelieerd aan <span class="filter-btn-wrap__highlight">${document.querySelector('.js-filter-owners-label-organisation').textContent.trim()}</span>`;
                }

                return (summary == 'Alle personen en organisaties') ? false : summary;
            }

        /*function _onUpdateError(jqxhr, textStatus, errorThrown, params)
        {
            document.querySelector(_overviewWrapSelector).classList.remove('loading-container--loading');
            //error?
            if (!userAbortedAjax(jqxhr)) alert(errorThrown);
        }*/

        function updateSummary()
        {
            const summary = _constructSummary();
            if (summary)
            {
                _filterButtonWrap.classList.add('filter-btn-wrap--with-summary');
                _summaryWrap.innerHTML = summary;
            }
            else
            {
                _filterButtonWrap.classList.remove('filter-btn-wrap--with-summary');
                _summaryWrap.innerHTML = '';
            }
        }



        function getFormValues()
        {
            const formValues = {};

            _textFields.forEach(function(fieldName)
            {
                formValues[fieldName] = _form.querySelector(`input[name="${fieldName}"]`).value;
            });
            _radioFields.forEach(function(fieldName)
            {
                const checkedField = _form.querySelector(`input[name="${fieldName}"]:checked`);
                formValues[fieldName] = checkedField ? checkedField.value : "";
            });

            return formValues;
        }

        function setFormValues(formValues)
        {
            const changeEvent = document.createEvent('HTMLEvents');
            changeEvent.initEvent('change', true, true);

            _textFields.forEach(function(fieldName)
            {
                const val = formValues[fieldName] || "";
                _form.querySelector(`input[name="${fieldName}"]`).value = val;
            });
            _radioFields.forEach(function(fieldName)
            {
                const val = formValues[fieldName] || "";
                const fieldToCheck = _form.querySelector(`input[name="${fieldName}"][value="${val}"]`);
                if (fieldToCheck)
                {
                    fieldToCheck.checked = true;
                    fieldToCheck.dispatchEvent(changeEvent);
                }
            });
        }





	//reveal public vars and functions
	return {
		//vars
        sidebarId,
        overviewWrapSelector,
		//functions
		init,
        contentLoaded,
        getFormValues,
        setFormValues,
        updateSummary
	};

})(jQuery);
